import {defineStore} from 'pinia'

// @ts-ignore
export const useSeminarStore = defineStore('seminar', {
  state: () => ({
    pathPrefix: '/seminar'
  }),
  getters: {},
  actions: {
    async postSeminarMailApplication(payload) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/mail-application`
      return await $apiClient(path, {
        method: 'POST',
        body: payload
      })
    },

    async postSeminarApplication(payload) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/application`
      return await $apiClient(path, {
        method: 'POST',
        body: payload
      })
    },
    async getMonthlySeminarList(type) {
      const {$apiClient} = useNuxtApp()
      const query = `?type=${type}`
      const path = `${this.pathPrefix}/monthly${query}`
      return await $apiClient(path, {
        method: 'GET'
      })
    },

    async getSeminarLocation() {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/location`
      return await $apiClient(path, {
        method: 'GET'
      })
    },

    async getMySeminarList() {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/my`
      return await $apiClient(path, {
        method: 'GET'
      })
    },
    async getMySeminarCertificate(seminarApplicationId) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/my/certificate/${seminarApplicationId}`
      return await $apiClient(path, {
        method: 'GET'
      })
    },
    /**
     * 교육강좌 조회
     * @returns {Promise<void>}
     */
    async getSeminarList(payload) {
      const {$apiClient} = useNuxtApp()
      let query = `?type=${payload.type}&page=${payload.page}&limit=${payload.limit}&keyword=${payload.keyword}`
      if (payload.pageType) {
        query += `&pageType=${payload.pageType}`
      }
      const path = `${this.pathPrefix}${query}`
      return await $apiClient(path, {
        method: 'GET'
      })
    },
    /**
     * 교육강좌 상세 조회
     * @returns {Promise<void>}
     */
    async getSeminarDetail(seminarId) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/${seminarId}`
      return await $apiClient(path, {
        method: 'GET'
      })
    },
    /**
     * 공개강좌 관련 파일 조회
     * @returns {Promise<void>}
     */
    async getSeminarFileList() {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/file`
      return await $apiClient(path, {
        method: 'GET'
      })
    },
    async getSeminarDiscount() {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/discount`
      return await $apiClient(path, {
        method: 'GET'
      })
    }
  }
})
